import React, { useEffect } from "react";

import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { motion } from "framer-motion";
import { useState } from "react";
import API_URL from "@/constant/api.config";
import axios from "axios";
import { Link } from "react-router-dom";

const Index = () => {

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay },
    }),
  };

  const [ourPartner, setOurPartner] = useState([]);
  const [limit, setLimit] = useState(250);

  const getPartners = async () => {
    try {
      const res = await axios.get(`${API_URL}/image-our-partners/${limit}`);
      setOurPartner(res?.data?.data || []);
      console.log("API Data:", res.data);
    } catch (error) {
      console.log("API Error:", error);
    }
  };

  useEffect(() => {
    getPartners();

    console.log("useEffect executed, fetching partners...");
  }, []);



  return (
    <section className="our-partners-section">

      {/* inner banner wrape START  */}
      <div className="inner-banner our-partner-page">
        <div className="container">
          <div className="content-wrape desk-hide">
            <h2>
              <motion.span className="light animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.1 }}
                custom={0.1}
                variants={fadeUpVariant}
              >Our</motion.span>
              <motion.span className="blue-text animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.1 }}
                custom={0.1}
                variants={fadeUpVariant}
              > Partners</motion.span>

            </h2>
            <motion.p className="animate-child"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.1 }}
              custom={0.1}
              variants={fadeUpVariant}
            >Stay connected with every opportunity-manage all inquiries effortlessly.</motion.p>
          </div>
        </div>
      </div>
      {/* inner banner wrape END  */}

      <section className="inner-page-content-wrape our-partner-wrape">
        <div className="container">
          <div className="content-wrape mobile-show page-head">
            <h2 className="mobile-head-text">
              <motion.span
                className="light animate-child"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                custom={0.1}
                variants={fadeUpVariant}
              >Our </motion.span>
              <motion.span className="blue-text">Partners </motion.span>
            </h2>
            <motion.p className="animate-child"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.1 }}
              custom={0.1}
              variants={fadeUpVariant}
            >Stay connected with every opportunity-manage all inquiries effortlessly.</motion.p>
          </div>
          <div className="row">
            {ourPartner.map((item, index) => {
              // console.log("Partner Item:", item);
              if (item?.image && item?.url) {
                const isExternal = !item.url.startsWith("/");
                const normalizedUrl = isExternal
                  ? item.url.startsWith("http")
                    ? item.url
                    : `https://${item.url}`
                  : item.url;

                return (
                  <div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-xs-12" key={item.id || index} >
                    <div className="box-wrape">
                      <Link
                        to={normalizedUrl}
                        {...(isExternal
                          ? { target: "_blank", rel: "noreferrer" }
                          : {})}
                        className="slide partner-logo-slide"
                        key={`partner-logo-slide-${index}-${item.title}`}
                      >
                        <img
                          src={item.image}
                          alt={item.companyName}
                        />
                      </Link>
                    </div>
                  </div>)
              } else {
                return null;
              }
            })}
          </div>
        </div>
      </section>
    </section>
  );
};

export default Index; 